import { useState } from 'react';
import { Modal } from '@mui/material';
import { Document, Page, pdfjs } from 'react-pdf';
import styles from './UserManualModal.module.scss';
import PropTypes from 'prop-types';
import CloseIcon from '@mui/icons-material/Close';
import { Loader } from 'src/components/Loader';

pdfjs.GlobalWorkerOptions.workerSrc =
	'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/4.4.168/pdf.worker.min.mjs';

export const UserManualModal = ({
	open,
	handleClose,
	PdfUrl,
	title,
	Modalloader,
}) => {
	const [pages, setPages] = useState(0);

	return (
		<Modal open={open} onClose={handleClose} className={styles.modal}>
			<>
				<div className={styles.modalTablecontainer}>
					{/* <div className={styles.closeIconContainerStyle}> */}
					<div className={styles.HeaderwithCloseIcon}>
						<div className={styles.header}>
							<span className={styles.ModalTitle}>{title}</span>
						</div>
						<div className={styles.closeIconStyle}>
							<CloseIcon onClick={handleClose} />
						</div>
					</div>
					{/* </div> */}
					<div className={styles.modalBody}>
						{Modalloader ? (
							<div className={styles.loaderDiv}>
								<Loader />
							</div>
						) : (
							<>
								{PdfUrl ? (
									<Document
										file={PdfUrl}
										onLoadSuccess={({ numPages }) => setPages(numPages)}
									>
										{Array.from(new Array(pages), (_, index) => (
											<Page
												className={styles.documentPageSection}
												key={index}
												pageIndex={index}
												renderTextLayer={false}
												renderAnnotationLayer={false}
											/>
										))}
									</Document>
								) : (
									<div className={styles.noDataText}>
										User Manual Not Found.
									</div>
								)}
							</>
						)}
					</div>
				</div>
			</>
		</Modal>
	);
};

UserManualModal.propTypes = {
	open: PropTypes.bool.isRequired,
	handleClose: PropTypes.func.isRequired,
};
